﻿//import { environment } from "src/environments/environment";

export class utils {
	public url: string;
	constructor() {
		this.url = "https://az-as-generadordocumentosssr.azurewebsites.net/"

	}
}